import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M9.998.595h.005c5.186 0 9.402 4.219 9.402 9.405 0 5.186-4.217 9.405-9.402 9.405a9.33 9.33 0 01-5.173-1.553l-3.616 1.155 1.172-3.495A9.336 9.336 0 01.596 10C.595 4.814 4.812.595 9.997.595zm-2.69 5.17c-.18-.43-.317-.446-.589-.457a5.242 5.242 0 00-.31-.01c-.354 0-.724.103-.948.331-.27.277-.947.922-.947 2.25 0 1.325.97 2.607 1.1 2.786.136.18 1.89 2.94 4.612 4.064 2.13.88 2.761.799 3.246.695.708-.152 1.595-.674 1.819-1.303.223-.631.223-1.169.158-1.283-.066-.114-.245-.179-.517-.315-.273-.136-1.596-.788-1.847-.875-.245-.091-.479-.06-.664.202-.262.363-.517.733-.725.956-.163.174-.43.196-.653.103-.299-.125-1.138-.418-2.173-1.337-.8-.711-1.345-1.597-1.502-1.863-.159-.272-.017-.43.109-.576.135-.168.266-.287.402-.445.137-.158.212-.24.3-.424.092-.18.027-.364-.039-.5-.065-.136-.61-1.463-.833-2z",
    fill: "#39C923"
  }));
}
export default SvgComponent;